import {DELETE_EVENTS_START} from "../../types";

export const delete_events = (payload) => ({
    type: DELETE_EVENTS_START,
    payload,
});
